const snakeCaseRegex = /_(\w|\d)/g;
const camelCaseRegex = /[A-Z]|\d+/g;

export const toCapitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);
export const toCamelCase = (str: string) => str.toLocaleLowerCase().replace(snakeCaseRegex, (match) => match.replace('_', '').toUpperCase());
export const toSnakeCase = (str: string) => str.replace(camelCaseRegex, (match) => `_${match.toLowerCase()}`);

/**
 * Simple mask function, improve as needed
 * If you need a much more complex mask, use a library
 */
export function simpleMask(str: string, mask: string) {
  if (!str || !mask) return str;

  return str.split('').reduce((acc, char) => acc.replace('#', char), mask);
}
